import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { SignUpService } from './sign-ups.service';
import { signup } from '../applicant/signup';
import { CommonService } from '../common/common.services';
import { Country } from '../common/country';
import { ProgrammeType } from '../common/programmeType';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { saveAs } from 'file-saver';
import { AllApplicantsService } from '../applicants/applicants.service';
import { AcademicYear } from '../applicants/AcademicYear';
import { Router } from '@angular/router';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-sign-ups',
  templateUrl: './sign-ups.component.html',
  styleUrls: ['./sign-ups.component.scss'],
})
export class SignUpsComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  displayedColumns: string[] = [
    'No',
    'FullName',
    'Gender',
    'ProgrammeTitle',
    'Nationality',
    'MobileNo',
    'Email',
    'Password',
    'Advert',
    'Date',
  ];

  dataSource: MatTableDataSource<signup>;
  signUpApplicants: signup[];
  sortedSignUpApplicants: signup[];
  certificateApplicants: signup[];
  degreeApplicants: signup[];
  diplomaApplicants: signup[];
  programmeTypeList: ProgrammeType[];
  countryList: Country[];
  downloadExcelFileUrl: string;
  fileUrl: string;
  totalApplicants: number;
  totalDiplomaApplicants: number;
  totalDegreeApplicants: number;
  totalCertificateApplicants: number;
  year: string;
  years: AcademicYear[];
  selected = '2023';

  public loading = false;

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private signUpService: SignUpService,
    private commonService: CommonService,
    private allApplicantsService: AllApplicantsService,
  ) {}

  ngOnInit(): void {
    this.loading = true
    this.allApplicantsService.getCurrentYear().subscribe((currentYear) => {
      console.log(currentYear.response);
      this.allApplicantsService.getAcademicYears().subscribe((response) => {
        this.years = response;
        this.year = currentYear.response;
        this.signUpService
          .getSignUpApplicants(this.year)
          .subscribe((signUpApplicantList) => {
            this.signUpApplicants = signUpApplicantList;
            this.commonService.getCountryList().subscribe((countryList) => {
              this.countryList = countryList;
              this.commonService
                .getProgrammeTypes()
                .subscribe((programmeTypeList) => {
                  this.programmeTypeList = programmeTypeList;
                  this.transformSignUpApplicants(
                    this.signUpApplicants,
                    this.countryList,
                    this.programmeTypeList,
                  );
                  this.populateApplicantsNo();
                  this.dataSource = new MatTableDataSource(
                    this.signUpApplicants,
                  );
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;
                  setTimeout(()=>{
                    this.loading = false;
                    console.log('Populated datasource: ' + this.dataSource);
                  }, 3000)
        
                });
            });
          });
      });
    });
  }

  fetchSignupList(year: string) {
    console.log('Selected year: ' + year);
    this.year = year;
    this.signUpService.getSignUpApplicants(year).subscribe((response) => {
      this.signUpApplicants = response;
      this.transformSignUpApplicants(
        this.signUpApplicants,
        this.countryList,
        this.programmeTypeList,
      );
      this.dataSource = new MatTableDataSource(this.signUpApplicants);
      this.dataSource.paginator = this.paginator;
      this.populateApplicantsNo();
    });
  }
  private populateApplicantsNo() {
    this.totalApplicants = this.signUpApplicants.length;
    this.totalDiplomaApplicants = this.signUpApplicants.filter(
      (applicant) => applicant.programme_type.indexOf('Diploma') !== -1,
    ).length;
    this.totalDegreeApplicants = this.signUpApplicants.filter(
      (applicant) => applicant.programme_type.indexOf('Bachelor') !== -1,
    ).length;
    this.totalCertificateApplicants = this.signUpApplicants.filter(
      (applicant) => applicant.programme_type.indexOf('Certificate') !== -1,
    ).length;
  }

  transformSignUpApplicants(
    signUpApplicants: signup[],
    countryList: Country[],
    programmeTypeList: ProgrammeType[],
  ) {
    signUpApplicants.forEach((signup) => {
      console.log(
        'sign up id ' +
          signup.first_name +
          ' programme type' +
          signup.programme_type,
      );
      signup.country_id = countryList.filter(
        (country) => country.countryCode === signup.country_id,
      )[0].country;
      signup.programme_type = this.transformProgrammeType(
        signup.programme_type,
        programmeTypeList,
      );
      signup.last_update = signup.last_update.substr(0, 10);
    });
  }

  transformProgrammeType(
    programme_type: string,
    programmeTypeList: ProgrammeType[],
  ) {
    let programmeType = programmeTypeList.filter(
      (programmeType) => programmeType.programmeTypeId === programme_type,
    );

    return programmeType[0].programmeType;
  }

  downloadExcelFile() {
    this.commonService.getCurrentYear().subscribe((response) => {
      let currentYear = response.response;
      this.signUpService
        .getSignUpApplicantsExcelFile(currentYear)
        .subscribe((blob) => {
          saveAs(blob, 'AUCDT SignUps.xlsx');
        });
    });
  }

  downloadCommentsExcelFile() {
    this.commonService.getCurrentYear().subscribe((response) => {
      let currentYear = response.response;
      this.signUpService
        .getSignUpApplicantsCommentsExcelFile()
        .subscribe((blob) => {
          saveAs(blob, 'AUCDT Signup Comments.xlsx');
        });
    });
  }

  populateApplicants(type: string) {
    console.log('Displaying data for: ' + type);
    switch (type) {
      case 'All':
        this.dataSource = new MatTableDataSource(this.signUpApplicants);
        this.dataSource.paginator = this.paginator;
        break;
      case 'Degree':
        this.degreeApplicants = this.signUpApplicants.filter(
          (applicant) => applicant.programme_type === 'Degree',
        );
        this.dataSource = new MatTableDataSource(this.degreeApplicants);
        this.dataSource.paginator = this.paginator;
        break;
      case 'Diploma':
        this.diplomaApplicants = this.signUpApplicants.filter(
          (applicant) => applicant.programme_type === 'Diploma',
        );
        this.dataSource = new MatTableDataSource(this.diplomaApplicants);
        this.dataSource.paginator = this.paginator;
        break;
      case 'Certificate':
        this.certificateApplicants = this.signUpApplicants.filter(
          (applicant) => applicant.programme_type === 'Certificate',
        );
        this.dataSource = new MatTableDataSource(this.certificateApplicants);
        this.dataSource.paginator = this.paginator;
        break;
    }
  }

  addComment(signUpId: string) {
    this.router.navigateByUrl('/comments?applicantId=' + signUpId);
  }

  sortData(sort: Sort) {
    this.sortedSignUpApplicants = this.signUpApplicants.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'No':
          return this.commonService.compare(a.sign_up_id, b.sign_up_id, isAsc);
        case 'FullName':
          return this.commonService.compare(a.first_name, b.first_name, isAsc);
        case 'Gender':
          return this.commonService.compare(a.gender, b.gender, isAsc);
        case 'ProgrammeTitle':
          return this.commonService.compare(
            a.programme_type,
            b.programme_type,
            isAsc,
          );
        case 'Nationality':
          return this.commonService.compare(a.country_id, b.country_id, isAsc);
        case 'MobileNo':
          return this.commonService.compare(a.contact_no, b.contact_no, isAsc);
        case 'Email':
          return this.commonService.compare(a.email, b.email, isAsc);
        case 'Advert':
          return this.commonService.compare(
            a.advertising,
            b.advertising,
            isAsc,
          );
        case 'Date':
          return this.commonService.compare(
            a.last_update,
            b.last_update,
            isAsc,
          );

        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.sortedSignUpApplicants);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
